import { DOCUMENT } from '@angular/common';
import { Component, Inject, Input, OnInit } from '@angular/core';

import TournamentBase from '../../tournament-base';

import { WINDOW } from '@core/http/window.providers';
import { LocalStorage } from '@core/localstorage';
import { el } from 'date-fns/locale';

@Component({
    selector: 'app-tournament-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
})
export class TournamentListComponent extends TournamentBase implements OnInit {
    /**
     * Definição da identificão da sessão/depto kids
     */
    departmentType: string = this.getDepartmentType();

    /**
     * loading: controla spinner na tela
     */
    loading: boolean = false;

    /**
     * columns ─ as colunas que serão renderizadas na tabela dentro do accordion
     * @type string[]
     */
    @Input() columns = ['Informações do Torneio', 'Local', 'Período Inscrições', 'Período Torneio'];

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    // registers: any;
    list: any;
    filters: any;

    loadAll = 1;

    constructor(@Inject(WINDOW) private window: Window, private localStorage: LocalStorage) {
        super();
        if (!this.departmentType) this.location.back();
    }

    ngOnInit(): void {
        this.tournamenList();
    }

    /**
     * tournamenList() - Buscar lista de torneios agrupados por mês dentro de um ano selecionado
     */
    tournamenList(filters = null) {
        this.loading = true;
        this.tournamentService.getTournaments(this.departmentType, filters).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    onTournamentClick(tournament) {
        if (tournament.redirect_site_personal) {
            const pathArray = tournament.redirect_site_personal.split('/');
            const host = pathArray.splice(0, 1);
            const currentUserToken = this.localStorage.getToken();
            const finalURL = `https://${host}/redirect-token?token=${currentUserToken}&path=${pathArray.join('/')}`;
            this.window.open(finalURL, '_blank');
            return;
        }
        this.router.navigate(['/' + tournament.route + '/tournament/', tournament.id_torneio]);
    }

    /**
     * onFilterChange(): Ao mudar parãmetro de filtro
     * @param event Objeto com parâmetros selecionados/alterado através do filtro
     */
    onFilterChange(event) {
        this.tournamenList(event);
        /**
         * TODO: fix me
         */
        this.loadAll = event.loadAll;
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.list = this.loadAll ? response.registers.list : this.list;
        this.filters = response.registers.filters;
        this.loading = false;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro

        this.loading = false;
    }

    scrollTo(elementRef: string) {
        document
            .getElementById(`refer-${elementRef}`)
            .scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
}
